import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Keyboard } from 'swiper';
import { formatImage } from '@ifeng-fe/public_method';
import GuestDraw from '../guestDraw';
import 'swiper/css';

const GuestMask = ({ guestMaskItemData, setIsGuestMask, onChangeCurrentVideo, onChangeMaskVisible }) => {
    const guestSayAndImageList = guestMaskItemData?.guestSayAndImageList || {};
    const guestVideoList = guestMaskItemData?.guestVideoList || [];
    const playVideoFirst = guestVideoList?.[0] || {};
    const playVideoImage = playVideoFirst?.thumbnails?.image?.[1]?.url || '';
    const drawData = guestSayAndImageList?.userImageList || [];
    const [showDrawStatus, setShowDrawStatus] = useState(0);
    const [videoPlayIndex, setVideoPlayIndex] = useState(-1);

    useEffect(() => {
        document.body.style.overflow = 'hidden';
    }, []);

    const closeGuestMask = () => {
        document.body.style.overflow = '';
        setIsGuestMask(false);
    };

    const openVideo = (videoData, playIndex = 0) => {
        setVideoPlayIndex(playIndex);
        onChangeCurrentVideo({
            url: videoData?.videoPlayUrl || '',
            guid: videoData?.guid || '',
            duration: videoData.duration || 0,
        });
        onChangeMaskVisible(true);
    };

    return (
        <div className={styles.guestMask}>
            <div className={styles.guestMaskClose} onClick={closeGuestMask} />
            <div className={`${styles.guestMaskBox} ${showDrawStatus === 1 ? styles.guestCloseMaskAnima : ''} ${showDrawStatus === 2 ? styles.guestOpenMaskAnima : ''}`}>
                {drawData?.length > 0 && (
                    <div
                        className={styles.guestMaskNextButton}
                        onClick={() => {
                            setShowDrawStatus(1);
                        }}
                    />
                )}
                <div className={styles.guestMaskContent}>
                    <a href={guestSayAndImageList?.userSayUrl} rel="noreferrer" target="_blank" className={styles.guestMaskSay} dangerouslySetInnerHTML={{ __html: guestSayAndImageList?.userSay }} />
                    <div
                        className={styles.guestMaskBigImage}
                        onClick={() => {
                            openVideo(playVideoFirst, -1);
                        }}>
                        <img className={styles.guestMaskBigPic} src={playVideoImage} />
                    </div>
                </div>
                <div className={styles.guestMaskSwiper}>
                    {guestVideoList.length >= 4 && (
                        <img
                            className={`${styles.navigation} ${styles.navigationPrev}`}
                            id="page2_prev"
                            src="https://x0.ifengimg.com/ucms/2023_48/11551243EA04C8F7E0030B9361D883F9CC775A32_size1_w32_h61.png"
                            alt=""
                        />
                    )}
                    {playVideoFirst?.thumbnail && (
                        <div
                            className={styles.guestMaskSwiperFirst}
                            onClick={() => {
                                openVideo(playVideoFirst, -1);
                            }}>
                            <div className={styles.guestMaskSwiperFirstPicBox}>
                                <img className={`${styles.guestMaskSwiperFirstPic} ${videoPlayIndex === -1 ? styles.active : ''}`} src={formatImage(playVideoFirst.thumbnail, 174, 96)} />
                            </div>
                            <div className={styles.guestMaskSwiperFirstText}>{playVideoFirst?.title || ''}</div>
                        </div>
                    )}
                    {guestVideoList?.[1] && (
                        <div className={styles.guestMaskSwiperBox}>
                            <div className={styles.guestMaskSwiperBoxScroll}>
                                <Swiper
                                    modules={[Navigation, Pagination, Keyboard]}
                                    slidesPerView={3}
                                    slidesPerGroup={3}
                                    loop={false}
                                    speed={1500}
                                    navigation={{
                                        prevEl: '#page2_prev',
                                        nextEl: '#page2_next',
                                    }}
                                    pagination={{
                                        el: `.${styles.pagination}`,
                                        type: 'fraction',
                                    }}
                                    keyboard={{
                                        enabled: true,
                                    }}>
                                    {guestVideoList.slice(1).map((item, index) => {
                                        return (
                                            <SwiperSlide key={index}>
                                                <div
                                                    onClick={() => {
                                                        openVideo(item, index);
                                                    }}
                                                    className={styles.swiperItem}>
                                                    <div className={styles.swiperItemPic}>
                                                        <img className={`${styles.swiperItemImage} ${videoPlayIndex === index ? styles.active : ''}`} src={formatImage(item?.thumbnail, 174, 96)} />
                                                    </div>
                                                    <div className={styles.swiperItemPicText}>{item.title}</div>
                                                </div>
                                            </SwiperSlide>
                                        );
                                    })}
                                </Swiper>
                            </div>
                        </div>
                    )}
                    {guestVideoList.length >= 4 && <div className={styles.pagination} />}
                    {guestVideoList.length >= 4 && (
                        <img
                            className={`${styles.navigation} ${styles.navigationNext}`}
                            id="page2_next"
                            src="https://x0.ifengimg.com/ucms/2023_48/E349BAF619C89BD4D84EC55B3F4FF601FAB33924_size1_w32_h61.png"
                        />
                    )}
                </div>
            </div>
            {showDrawStatus !== 0 && <GuestDraw drawData={drawData} showDrawStatus={showDrawStatus} setShowDrawStatus={setShowDrawStatus} closeGuestMask={closeGuestMask} />}
        </div>
    );
};

GuestMask.propTypes = {
    guestMaskItemData: PropTypes.object,
    setIsGuestMask: PropTypes.func,
    onChangeMaskVisible: PropTypes.func,
    onChangeCurrentVideo: PropTypes.func,
};

export default errorBoundary(GuestMask);
